// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__et8+v","button":"styles_button__czq-a","heading":"styles_heading__IYOlP"};